import React, { useEffect, useState} from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import CpntForm from "../../../components/forms/CpntForm";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import TextInput from "../../../components/forms/TextInput";
import CpntFormSectionNavigation from "../../../components/forms/CpntFormSectionNavigation";
import { Button} from "react-bootstrap";
//import { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";

import SelectInput from "../../../components/forms/SelectInput";
import { useFetchPaysQuery, useFetchSecteurActiviteQuery } from "../../../redux/slice/api/staticData";
import { IFormOrganisation, IFormSociete } from "../../../models/interfaces/IFormOrganisation";
import { ModulesList, TypeCompteSociete, validationMode } from "../../../config/helpers";
import { FRANCE_ET_ASSIMILES_IDS } from "../../../utils/helpers";
import { getOrganisationSchema } from "../../../models/schema/OrganisationSchema";
import { useSirenValidation } from "../../../hooks/useSirenValidation";
import { useBOSocieteCompteUpdateMutation, useBOSocieteUpdateModulesMutation, useFetchBOSocieteCompteQuery } from "../../../redux/slice/api/BO/societeApi";
import { useKeycloak } from "@react-keycloak/web";
import { toast } from "react-toastify";
import SpinnerEditeurPro from "../../FO/components/SpinnerEditeurPro";


interface IProps {
    IdSociete: number;
    ReadOnlyServicePart: boolean;
    handleRaisonSociale?: (value: string) => void;
  }


const SocieteInformationsBO: React.FC<IProps> = ({IdSociete,ReadOnlyServicePart,handleRaisonSociale}:IProps) => {
  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
  const { data: secteurActivites } = useFetchSecteurActiviteQuery();
  const { data: pays } = useFetchPaysQuery();

  const { refetch:refetchBOSocieteCompte,data: SocieteCompteResult, isFetching: SocieteCompteisFetching, error: SocieteCompteerror } = useFetchBOSocieteCompteQuery(IdSociete ?? 0, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || IdSociete === 0
  });

  const [activeModules, setActiveModules] = useState<number[]>([]);
  const [isInitialized, setIsInitialized] = useState<boolean>(false);
  const hasSetValuesRef = React.useRef<boolean>(false);
  
  // Référence pour l'erreur API SIREN
  const sirenApiErrorRef = React.useRef<string | null>(null);

  // Créer un resolver dynamique qui utilise la référence
  const dynamicResolver = React.useMemo(
    () => async (values: any, context: any, options: any) => {
      const schema = getOrganisationSchema(sirenApiErrorRef.current);
      return yupResolver(schema)(values, context, options);
    },
    []
  );

  const handleToggle = async (moduleId:number) => {
    const updatedModules = activeModules.includes(moduleId)
      ? activeModules.filter((id) => id !== moduleId) // Désactiver le module
      : [...activeModules, moduleId]; // Activer le module

    setActiveModules(updatedModules); // Mise à jour locale
    await BOSocieteUpdateModules(
      {
        IdSociete: IdSociete,
       Modules: updatedModules
      }); // Envoi des modifications
  };

  // useEffect(() => {
  // console.log(activeModules);
  // }, [activeModules])

  const [
    BOSocieteUpdateModules,
    {
    data : dataBOSocieteUpdateModules,
    isSuccess: isSuccessUpdateModules,
    error: errorBOSocieteUpdateModules,
    isLoading: isLoadingUpdateModules
  }] = useBOSocieteUpdateModulesMutation();

  
    const formMethodsSociete = useForm<IFormOrganisation | any>({
        mode: "all",
        reValidateMode: "onChange",
        resolver: dynamicResolver as any
      });

      // setValue, setError, clearErrors,getValues
      const { handleSubmit:handleSubmitSociete, setValue:setValueSociete, watch, trigger} = formMethodsSociete;
        
      useEffect(() => {
        if (SocieteCompteResult?.Societe && !hasSetValuesRef.current) {
          handleRaisonSociale && handleRaisonSociale(SocieteCompteResult?.Societe?.RaisonSociale ? SocieteCompteResult?.Societe.RaisonSociale : "");

          setValueSociete("Siren", SocieteCompteResult?.Societe?.Siren ? SocieteCompteResult?.Societe.Siren : "");
          setValueSociete("RaisonSocialeSiren", SocieteCompteResult?.Societe?.RaisonSociale ? SocieteCompteResult?.Societe.RaisonSociale : "");
          setValueSociete("IdTypeCompteSociete", SocieteCompteResult?.Societe?.IdTypeCompteSociete ? SocieteCompteResult?.Societe.IdTypeCompteSociete : -1);
          setValueSociete("IdSecteurActivite", SocieteCompteResult?.Societe?.IdSecteurActivite ? SocieteCompteResult?.Societe.IdSecteurActivite : -1);
          setValueSociete("RaisonSociale", SocieteCompteResult?.Societe?.RaisonSociale ? SocieteCompteResult?.Societe.RaisonSociale : "");
          setValueSociete("SiteInternet", SocieteCompteResult?.Societe?.SiteInternet ? SocieteCompteResult?.Societe.SiteInternet : "");
          setValueSociete("Adresse", SocieteCompteResult?.Societe?.Adresse ? SocieteCompteResult?.Societe.Adresse : "");
          setValueSociete("Ville", SocieteCompteResult?.Societe?.Ville ? SocieteCompteResult?.Societe.Ville : "");
          setValueSociete("CodePostal", SocieteCompteResult?.Societe?.CodePostal ?SocieteCompteResult?. Societe.CodePostal : "");
          setValueSociete("IdPays", SocieteCompteResult?.Societe?.IdPays ? SocieteCompteResult?.Societe.IdPays : "");
          setActiveModules(SocieteCompteResult?.Societe?.Modules ?? []);
          
          hasSetValuesRef.current = true;
          // Marquer comme initialisé pour déclencher la validation SIREN
          setTimeout(() => setIsInitialized(true), 100);
        }
      }, [SocieteCompteResult?.Societe, setValueSociete, handleRaisonSociale])

      const watchIdPays = watch("IdPays");
      const watchSiren = watch("Siren");

      // Hook de validation SIREN
      const { sirenApiError } = useSirenValidation({
        siren: watchSiren,
        isFranceOrAssimile: watchIdPays ? FRANCE_ET_ASSIMILES_IDS.includes(Number(watchIdPays)) : false,
        idSociete: IdSociete,
        setValue: setValueSociete,
        trigger,
        raisonSocialeSirenFieldName: "RaisonSocialeSiren",
        raisonSocialeFieldName: "RaisonSociale",
        showToasts: true,
        fillRaisonSociale: false
      });

      // Mettre à jour la ref sirenApiError et re-valider quand elle change
      useEffect(() => {
        sirenApiErrorRef.current = sirenApiError || null;
        if (watchSiren) {
          // Re-vérifier la validation du champ Siren
          trigger("Siren");
        }
      }, [sirenApiError, watchSiren, trigger]);
      
      useEffect(() => {
        // Revalider le champ Siren quand IdPays change
        if (watchIdPays !== undefined) {
          trigger("Siren");
        }
      }, [watchIdPays, trigger]);

      // Appeler l'API SIREN au chargement si un SIREN existe
      useEffect(() => {
        if (isInitialized &&
            watchSiren && 
            watchSiren.length === 9 &&
            watchIdPays && 
            FRANCE_ET_ASSIMILES_IDS.includes(Number(watchIdPays))) {
          // Le hook useSirenValidation se déclenchera automatiquement
          // On force juste un trigger pour s'assurer
          trigger("Siren");
        }
      }, [isInitialized, watchSiren, watchIdPays, trigger]);

      const onErrorSociete = (errors: any) => {
        //
      };

      const { reset:resetSociete } =
      formMethodsSociete;
      const [
        updateSociete,
        {
        isSuccess: isSuccessUpdateSociete,
        error: errorUpdateSociete,
      }] = useBOSocieteCompteUpdateMutation();
    
      useEffect(() => {
        if (errorUpdateSociete !== undefined) {
          toast.warn("Les modifications n'ont pas été prises en compte");
          //setUpdateError(errorUpdateBO)
        }
    }, [errorUpdateSociete])
    
    useEffect(() => {
      if (isSuccessUpdateSociete) {
        toast.success("Les modifications ont bien été prises en compte.");
        // setPublication(publication);
        // setUpdateSuccess(true);
      }
    }, [isSuccessUpdateSociete])
    
      const onSubmitSociete: SubmitHandler<IFormSociete> = (data) => {
        // Si le pays n'est pas France ou assimilé, vider le SIREN et la raison sociale SIREN
        const isFrance = data.IdPays ? FRANCE_ET_ASSIMILES_IDS.includes(Number(data.IdPays)) : false;
        
        updateSociete(
          {
            ...data,
            Id: SocieteCompteResult?.Societe?.IdSociete ?? -1,
            Siren: isFrance ? data.Siren : "", // Vider le SIREN si pas France
            RaisonSocialeSiren: isFrance ? data.RaisonSocialeSiren : "" // Vider la raison sociale SIREN si pas France
          }
        );
      };
      
      useEffect(() => {
        if (SocieteCompteResult) {
          resetSociete({
            Siren: SocieteCompteResult?.Societe?.Siren,
            RaisonSocialeSiren: SocieteCompteResult?.Societe?.RaisonSociale,
            RaisonSociale : SocieteCompteResult?.Societe?.RaisonSociale,
            IdTypeCompteSociete: SocieteCompteResult?.Societe?.IdTypeCompteSociete,
            SiteInternet : SocieteCompteResult?.Societe?.SiteInternet,
            Adresse: SocieteCompteResult?.Societe?.Adresse,
            CodePostal: SocieteCompteResult?.Societe?.CodePostal,
            IdPays: SocieteCompteResult?.Societe?.IdPays,
            Ville: SocieteCompteResult?.Societe?.Ville,
            IdSecteurActivite: SocieteCompteResult?.Societe?.IdSecteurActivite,
          });
        }
      }, [SocieteCompteResult])
       

      useEffect(() => {
        if (errorBOSocieteUpdateModules !== undefined) {
          toast.warn("Les modifications n'ont pas été prises en compte");
          refetchBOSocieteCompte();
        }
    }, [errorBOSocieteUpdateModules])

    
  useEffect(() => {
    if (isSuccessUpdateModules) {
      toast.success("Les modifications ont bien été prises en compte.");
      if (dataBOSocieteUpdateModules) {
        setActiveModules(dataBOSocieteUpdateModules?.Societe?.Modules ?? []);
      }
      
    }
  }, [isSuccessUpdateModules])

    return (
        <>
        
        {SocieteCompteisFetching ? (
          <SpinnerEditeurPro />
  ) : SocieteCompteerror ? (
    <div>Error</div>
  ) : (
<>
<div className="row pt-3 pb-4">
<div className="col col-md-10 offset-md-1 col-12 ">
<FormProvider {...formMethodsSociete}>
      <form onSubmit={handleSubmitSociete((data) => onSubmitSociete(data),onErrorSociete)}>
      <CpntForm>
        <CpntFormSection pSectionLabel="Information sur la raison sociale">
              <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[6,6,6,6,6,6,6,6,6]}>
              {watchIdPays && FRANCE_ET_ASSIMILES_IDS.includes(Number(watchIdPays)) && (
                <>
                  <TextInput
                    label="N° Siren"
                    formName="Siren"
                    validationStyle={validationMode.classic}
                    placeholder="Numéro SIREN (9 chiffres)"
                    ismandatory={true}
                    disabled={false}
                  />
                  <TextInput
                    label="Raison sociale (SIREN)"
                    formName="RaisonSocialeSiren"
                    validationStyle={validationMode.classic}
                    placeholder="Récupérée automatiquement"
                    disabled={true}
                  />
                </>
              )}
                <SelectInput
                disabled={true}
                  label="Type Compte Société"
                  formName="IdTypeCompteSociete"
                  ismandatory={true}
                  options={TypeCompteSociete.map((tc) => {
                    return {
                      Id: tc.Id,
                      Libelle: tc.Libelle,
                      //defaultChecked: civ.Id,
                    };
                  })}
                />
                <SelectInput
                  label="Secteur d’activité"
                  formName="IdSecteurActivite"
                  ismandatory={false}
                  options={secteurActivites?.SecteurActivites?.map((tc) => {
                    return {
                      Id: tc.Id,
                      Libelle: tc.Libelle,
                      //defaultChecked: civ.Id,
                    };
                  })}
                />
                <TextInput
                  label="Nom"
                  formName="RaisonSociale"
                  validationStyle={validationMode.classic}
                  placeholder="Nom"
                  ismandatory={true}
                />
                <TextInput
                  label="Site internet"
                  formName="SiteInternet"
                  validationStyle={validationMode.classic}
                  placeholder="Site internet"
                  ismandatory={false}
                />
                <TextInput
                  label="Adresse postale"
                  formName="Adresse"
                  validationStyle={validationMode.classic}
                  placeholder="Adresse postale"
                  ismandatory={true}
                />
                 <TextInput
                  label="Ville"
                  formName="Ville"
                  validationStyle={validationMode.classic}
                  placeholder="Ville"
                  ismandatory={true}
                />
                 <TextInput
                  label="Code postal"
                  formName="CodePostal"
                  validationStyle={validationMode.classic}
                  placeholder="Code postal"
                  ismandatory={false}
                  maxLength={11}
                />
                <SelectInput
                  label="Pays"
                  formName="IdPays"
                  ismandatory={true}
                  options={pays?.Pays?.map((pays) => {
                    return {
                      Id: pays.Id,
                      Libelle: pays.Libelle,
                    };
                  })}
                />
              </CpntFormSectionContainer>
              <CpntFormSectionNavigation>
                {/* <div></div> */}
                <Button type="submit" className="btn-secondary col-12">
                  Enregistrer
                </Button>
                {/* <div></div> */}
              </CpntFormSectionNavigation>

        </CpntFormSection>
      </CpntForm>
    </form>
</FormProvider>
</div>
</div>
<div className="row pt-1 pb-5">
  <div className="col col-md-5 offset-md-1 col-12 "> 
    <div className="card form-card">
      <div className="card-body form-container text-start">
      <div className="d-flex"><p className="h6lpe me-4"><b>Les services de l&apos;organisation</b></p></div>
      {
      ReadOnlyServicePart ?
      ModulesList.map((mod) => (
        <><span>{mod.Libelle}</span> : <b>{ SocieteCompteResult?.Societe?.Modules?.find(mid => mid === mod.Id) ? <i style={{padding: "0px 5px"}} className="text-green">Actif</i> : <i style={{padding: "0px 5px"}} className="text-redlight">Inactif</i>}</b><br/></>
        ))
    :
    ModulesList.map((mod) => (
      <div key={mod.Id} className="form-check form-switch mb-2">
      <input
        className={`form-check-input ${activeModules.includes(mod.Id) ? "bg-green":"bg-grey"}`}
        type="checkbox"
        id={`module-${mod.Id}`}
        checked={activeModules.includes(mod.Id)}
        onChange={() => handleToggle(mod.Id)}
        disabled={isLoadingUpdateModules} 
      />
      <label className="form-check-label" htmlFor={`module-${mod.Id}`}>
        <span>{mod.Libelle}</span>
      </label>
    </div>
  ))
    }
      </div>
    </div>
  </div>
  <div className="col col-md-5 col-12 "> 
    <div className="card form-card">
      <div className="card-body form-container text-start">
      <div className="d-flex"><p className="h6lpe me-4"><b>L&apos;Administrateur de l&apos;organisation</b></p></div>
      <>
              <b>{SocieteCompteResult?.Societe?.Administrateur?.Nom}</b> {SocieteCompteResult?.Societe?.Administrateur?.Prenom}<br />
              <b>Coordonnées :</b><br />
              {SocieteCompteResult?.Societe?.Administrateur?.Email} / {SocieteCompteResult?.Societe?.Administrateur?.Telephone}
              </>

      </div>
    </div>
  </div>
</div>
</>
  )} 

        </>
        );
};

export default SocieteInformationsBO;

